/**
 * CONFIGURACIÓN — Previsión de necesidad de metal (Estado Oro)
 * =============================================================================
 * Modifica este archivo para ajustar vacaciones, festivos o cierres de fábrica.
 *
 * Los días dentro de METAL_NEED_EXCLUDED_PERIODS NO cuentan al calcular
 * las 6 semanas (42 días efectivos) de antelación del horizonte.
 *
 * Los tramos de la tabla se agrupan por quincenas naturales (días 1–15 y 16–fin
 * de mes). Las quincenas enteras en vacaciones no generan columna.
 *
 * Formato de fechas: 'YYYY-MM-DD' (inicio y fin inclusive).
 */

/** Semanas de antelación: el metal debe estar disponible este tiempo antes de la entrega */
export const METAL_NEED_LEAD_WEEKS = 6;
export const METAL_NEED_LEAD_TIME_DAYS = METAL_NEED_LEAD_WEEKS * 7;

/** Número de columnas/tramos en la tabla (incluye «Necesidad actual») */
export const METAL_NEED_QUINCENA_BUCKET_COUNT = 5;

/** Provisión para fundición (casting): +28 % sobre el metal fino requerido */
export const METAL_NEED_PROVISION_FACTOR = 1.28;

/**
 * Precio manual del titanio (€/g) para calcular importes en la previsión.
 * La API pública de Rzzro no incluye titanio (solo metales LME base).
 * Pon aquí el precio de referencia si lo conoces; null = sin importe para titanio.
 */
export const METAL_TITANIUM_EUR_PER_GRAM = null;

/**
 * Periodos excluidos del cómputo (no laborables).
 * @type {Array<{ id: string, label: string, from: string, to: string }>}
 */
export const METAL_NEED_EXCLUDED_PERIODS = [
  {
    id: "vacaciones-agosto-2026",
    label: "Vacaciones agosto (3 primeras semanas)",
    from: "2026-08-01",
    to: "2026-08-21",
  },
];
